import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, vModelSelect as _vModelSelect, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "card shadow-sm" }
const _hoisted_2 = { class: "card-body" }
const _hoisted_3 = { class: "row g-3 mb-3" }
const _hoisted_4 = { class: "col-12" }
const _hoisted_5 = {
  key: 0,
  class: "text-danger me-1"
}
const _hoisted_6 = ["readonly"]
const _hoisted_7 = { class: "col-12" }
const _hoisted_8 = ["readonly"]
const _hoisted_9 = { class: "table-responsive" }
const _hoisted_10 = { class: "table table-sm align-middle" }
const _hoisted_11 = { key: 0 }
const _hoisted_12 = { class: "text-center" }
const _hoisted_13 = { class: "input-group input-group-sm align-items-stretch" }
const _hoisted_14 = ["onUpdate:modelValue", "onInput", "onBlur", "onChange", "readonly"]
const _hoisted_15 = {
  class: "input-group-text bg-white",
  style: {"min-width":"2.25rem"}
}
const _hoisted_16 = {
  key: 0,
  class: "fas fa-spinner fa-spin text-secondary small fa-fw"
}
const _hoisted_17 = {
  key: 1,
  class: "fas fa-exclamation-triangle text-danger small fa-fw",
  title: "Dirección duplicada"
}
const _hoisted_18 = {
  key: 2,
  class: "fas fa-check text-success small fa-fw",
  title: "Dirección válida"
}
const _hoisted_19 = {
  key: 3,
  class: "fas fa-times text-danger small fa-fw",
  title: "Dirección inválida"
}
const _hoisted_20 = {
  key: 0,
  class: "text-danger small mt-1"
}
const _hoisted_21 = { class: "text-center" }
const _hoisted_22 = ["onUpdate:modelValue", "onChange", "disabled"]
const _hoisted_23 = { class: "input-group input-group-sm" }
const _hoisted_24 = ["onUpdate:modelValue", "onInput", "readonly"]
const _hoisted_25 = ["value"]
const _hoisted_26 = { class: "input-group input-group-sm" }
const _hoisted_27 = ["onUpdate:modelValue", "onInput", "readonly"]
const _hoisted_28 = ["value"]
const _hoisted_29 = ["onUpdate:modelValue", "readonly"]
const _hoisted_30 = { class: "text-center" }
const _hoisted_31 = ["onClick", "disabled"]
const _hoisted_32 = { key: 1 }
const _hoisted_33 = {
  colspan: "7",
  class: "text-danger small"
}
const _hoisted_34 = { key: 2 }
const _hoisted_35 = {
  colspan: "7",
  class: "text-warning small"
}
const _hoisted_36 = ["disabled"]
const _hoisted_37 = { class: "text-end text-nowrap pe-2" }
const _hoisted_38 = { class: "text-end text-nowrap pe-2" }
const _hoisted_39 = {
  key: 0,
  class: "card-footer d-flex flex-wrap align-items-center gap-2"
}
const _hoisted_40 = {
  key: 0,
  class: "text-muted small"
}
const _hoisted_41 = ["disabled"]
const _hoisted_42 = {
  key: 0,
  class: "fas fa-spinner fa-spin ms-1"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          (_ctx.isEditable)
            ? (_openBlock(), _createElementBlock("span", _hoisted_5, "*"))
            : _createCommentVNode("", true),
          _cache[6] || (_cache[6] = _createElementVNode("label", {
            class: "form-label fw-semibold",
            for: "withdrawal-concept"
          }, " Concepto ", -1)),
          _withDirectives(_createElementVNode("input", {
            id: "withdrawal-concept",
            type: "text",
            class: "form-control",
            maxlength: "120",
            placeholder: "Concepto del Retiro",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.concept) = $event)),
            readonly: !_ctx.isEditable
          }, null, 8, _hoisted_6), [
            [
              _vModelText,
              _ctx.concept,
              void 0,
              { trim: true }
            ]
          ])
        ]),
        _createElementVNode("div", _hoisted_7, [
          _cache[7] || (_cache[7] = _createElementVNode("label", {
            class: "form-label fw-semibold",
            for: "withdrawal-note"
          }, " Notas del retiro (opcional) ", -1)),
          _withDirectives(_createElementVNode("textarea", {
            id: "withdrawal-note",
            class: "form-control",
            rows: "2",
            maxlength: "200",
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.transactionNote) = $event)),
            readonly: !_ctx.isEditable
          }, null, 8, _hoisted_8), [
            [_vModelText, _ctx.transactionNote]
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("table", _hoisted_10, [
          _cache[19] || (_cache[19] = _createElementVNode("thead", null, [
            _createElementVNode("tr", null, [
              _createElementVNode("th", {
                class: "text-center",
                style: {"width":"3rem"}
              }, "#"),
              _createElementVNode("th", {
                class: "text-nowrap",
                style: {"min-width":"16rem"}
              }, "Dirección"),
              _createElementVNode("th", {
                class: "text-center text-nowrap",
                style: {"min-width":"8rem"}
              }, " Moneda "),
              _createElementVNode("th", {
                class: "text-center text-nowrap",
                style: {"min-width":"10rem"}
              }, " Monto (USD) "),
              _createElementVNode("th", {
                class: "text-center text-nowrap",
                style: {"min-width":"10rem"}
              }, " Monto (BTC) "),
              _createElementVNode("th", {
                class: "text-nowrap",
                style: {"min-width":"12rem"}
              }, "Nota"),
              _createElementVNode("th", {
                class: "text-center",
                style: {"width":"3rem"}
              })
            ])
          ], -1)),
          _createElementVNode("tbody", null, [
            (_ctx.recipients.length === 0)
              ? (_openBlock(), _createElementBlock("tr", _hoisted_11, [...(_cache[8] || (_cache[8] = [
                  _createElementVNode("td", {
                    colspan: "7",
                    class: "text-center text-muted"
                  }, " Agrega al menos un destino ", -1)
                ]))]))
              : _createCommentVNode("", true),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.recipients, (recipient, index) => {
              return (_openBlock(), _createElementBlock("tr", {
                key: recipient.id,
                class: "align-top"
              }, [
                _createElementVNode("td", _hoisted_12, _toDisplayString(index + 1), 1),
                _createElementVNode("td", null, [
                  _createElementVNode("div", _hoisted_13, [
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      class: _normalizeClass(_ctx.addressInputClass(recipient)),
                      placeholder: "bc1...",
                      "onUpdate:modelValue": ($event: any) => ((recipient.address) = $event),
                      onInput: ($event: any) => (_ctx.onAddressInput(recipient)),
                      onBlur: ($event: any) => (_ctx.validateAddress(recipient)),
                      onChange: ($event: any) => (_ctx.validateAddress(recipient)),
                      readonly: !_ctx.isEditable
                    }, null, 42, _hoisted_14), [
                      [
                        _vModelText,
                        recipient.address,
                        void 0,
                        { trim: true }
                      ]
                    ]),
                    _createElementVNode("span", _hoisted_15, [
                      (recipient.addressChecking)
                        ? (_openBlock(), _createElementBlock("i", _hoisted_16))
                        : (_ctx.addressIsDuplicate(recipient))
                          ? (_openBlock(), _createElementBlock("i", _hoisted_17))
                          : (recipient.addressValid === true)
                            ? (_openBlock(), _createElementBlock("i", _hoisted_18))
                            : (recipient.addressValid === false)
                              ? (_openBlock(), _createElementBlock("i", _hoisted_19))
                              : _createCommentVNode("", true)
                    ])
                  ]),
                  (
                    recipient.addressValid === false &&
                    !_ctx.addressIsDuplicate(recipient)
                  )
                    ? (_openBlock(), _createElementBlock("div", _hoisted_20, " Dirección inválida "))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("td", _hoisted_21, [
                  _withDirectives(_createElementVNode("select", {
                    class: "form-select form-select-sm",
                    "onUpdate:modelValue": ($event: any) => ((recipient.currency) = $event),
                    onChange: ($event: any) => (_ctx.onCurrencyChange(recipient)),
                    disabled: !_ctx.isEditable
                  }, [...(_cache[9] || (_cache[9] = [
                    _createElementVNode("option", { value: "USD" }, "USD", -1),
                    _createElementVNode("option", { value: "BTC" }, "BTC", -1)
                  ]))], 40, _hoisted_22), [
                    [_vModelSelect, recipient.currency]
                  ])
                ]),
                _createElementVNode("td", null, [
                  _createElementVNode("div", _hoisted_23, [
                    (recipient.currency === 'USD')
                      ? _withDirectives((_openBlock(), _createElementBlock("input", {
                          key: 0,
                          type: "text",
                          inputmode: "decimal",
                          class: "form-control text-end",
                          "onUpdate:modelValue": ($event: any) => ((recipient.amountUsd) = $event),
                          onKeypress: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.blockNonNumeric && _ctx.blockNonNumeric(...args))),
                          onInput: ($event: any) => (_ctx.onUsdChange(recipient)),
                          readonly: !_ctx.isEditable
                        }, null, 40, _hoisted_24)), [
                          [_vModelText, recipient.amountUsd]
                        ])
                      : (_openBlock(), _createElementBlock("input", {
                          key: 1,
                          type: "text",
                          class: "form-control text-end",
                          value: _ctx.formatUsdDisplay(_ctx.rowUsd(recipient)),
                          readonly: "",
                          tabindex: "-1"
                        }, null, 8, _hoisted_25)),
                    _cache[10] || (_cache[10] = _createElementVNode("span", { class: "input-group-text" }, "USD", -1))
                  ])
                ]),
                _createElementVNode("td", null, [
                  _createElementVNode("div", _hoisted_26, [
                    (recipient.currency === 'BTC')
                      ? _withDirectives((_openBlock(), _createElementBlock("input", {
                          key: 0,
                          type: "text",
                          inputmode: "decimal",
                          class: "form-control text-end",
                          "onUpdate:modelValue": ($event: any) => ((recipient.amountBtc) = $event),
                          onKeypress: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.blockNonNumeric && _ctx.blockNonNumeric(...args))),
                          onInput: ($event: any) => (_ctx.onBtcChange(recipient)),
                          readonly: !_ctx.isEditable
                        }, null, 40, _hoisted_27)), [
                          [_vModelText, recipient.amountBtc]
                        ])
                      : (_openBlock(), _createElementBlock("input", {
                          key: 1,
                          type: "text",
                          class: "form-control text-end",
                          value: _ctx.formatBtcDisplay(_ctx.rowBtc(recipient)),
                          readonly: "",
                          tabindex: "-1"
                        }, null, 8, _hoisted_28)),
                    _cache[11] || (_cache[11] = _createElementVNode("span", { class: "input-group-text" }, "BTC", -1))
                  ])
                ]),
                _createElementVNode("td", null, [
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    maxlength: "80",
                    class: "form-control form-control-sm",
                    "onUpdate:modelValue": ($event: any) => ((recipient.note) = $event),
                    readonly: !_ctx.isEditable
                  }, null, 8, _hoisted_29), [
                    [_vModelText, recipient.note]
                  ])
                ]),
                _createElementVNode("td", _hoisted_30, [
                  _createElementVNode("button", {
                    class: "btn btn-outline-danger btn-sm",
                    type: "button",
                    onClick: ($event: any) => (_ctx.removeRecipient(recipient.id)),
                    disabled: !_ctx.isEditable || !_ctx.allowRemove,
                    title: "Eliminar destino"
                  }, [...(_cache[12] || (_cache[12] = [
                    _createElementVNode("i", { class: "far fa-trash-alt" }, null, -1)
                  ]))], 8, _hoisted_31)
                ])
              ]))
            }), 128)),
            (_ctx.errorMessages.length)
              ? (_openBlock(), _createElementBlock("tr", _hoisted_32, [
                  _createElementVNode("td", _hoisted_33, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.errorMessages, (msg, idx) => {
                      return (_openBlock(), _createElementBlock("div", {
                        class: "d-flex align-items-start gap-2",
                        key: `err-${idx}`
                      }, [
                        _cache[13] || (_cache[13] = _createElementVNode("i", { class: "fas fa-exclamation-triangle mt-1" }, null, -1)),
                        _createElementVNode("span", null, _toDisplayString(msg), 1)
                      ]))
                    }), 128))
                  ])
                ]))
              : _createCommentVNode("", true),
            (_ctx.warningMessages.length)
              ? (_openBlock(), _createElementBlock("tr", _hoisted_34, [
                  _createElementVNode("td", _hoisted_35, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.warningMessages, (msg, idx) => {
                      return (_openBlock(), _createElementBlock("div", {
                        class: "d-flex align-items-start gap-2",
                        key: `warn-${idx}`
                      }, [
                        _cache[14] || (_cache[14] = _createElementVNode("i", { class: "fas fa-exclamation-triangle mt-1" }, null, -1)),
                        _createElementVNode("span", null, _toDisplayString(msg), 1)
                      ]))
                    }), 128))
                  ])
                ]))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("tfoot", null, [
            _createElementVNode("tr", null, [
              _cache[16] || (_cache[16] = _createElementVNode("td", null, null, -1)),
              _createElementVNode("td", null, [
                _createElementVNode("button", {
                  class: "btn btn-outline-secondary btn-sm",
                  onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.addRecipient && _ctx.addRecipient(...args))),
                  disabled: !_ctx.isEditable || !_ctx.allowAdd
                }, [...(_cache[15] || (_cache[15] = [
                  _createElementVNode("i", { class: "fas fa-plus me-1" }, null, -1),
                  _createTextVNode("Agregar destino ", -1)
                ]))], 8, _hoisted_36)
              ]),
              _cache[17] || (_cache[17] = _createElementVNode("td", { class: "fw-bold text-end pe-2" }, "Total:", -1)),
              _createElementVNode("td", _hoisted_37, " $ " + _toDisplayString(_ctx.formatUsdDisplay(_ctx.totalUsd)) + " USD ", 1),
              _createElementVNode("td", _hoisted_38, _toDisplayString(_ctx.formatBtcDisplay(_ctx.totalBtc)) + " BTC ", 1),
              _cache[18] || (_cache[18] = _createElementVNode("td", { colspan: "2" }, null, -1))
            ])
          ])
        ])
      ])
    ]),
    (_ctx.showSubmit)
      ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
          (_ctx.availableBtcValue > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_40, " Disponible: " + _toDisplayString(_ctx.formatBtcDisplay(_ctx.availableBtcValue)) + " BTC ", 1))
            : _createCommentVNode("", true),
          _createElementVNode("button", {
            class: "btn btn-primary ms-auto",
            type: "button",
            onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.emitSubmit && _ctx.emitSubmit(...args))),
            disabled: !_ctx.canSubmit
          }, [
            _cache[20] || (_cache[20] = _createElementVNode("i", { class: "fas fa-save me-1" }, null, -1)),
            _createTextVNode(" " + _toDisplayString(_ctx.submitLabelText) + " ", 1),
            (_ctx.loadingState)
              ? (_openBlock(), _createElementBlock("i", _hoisted_42))
              : _createCommentVNode("", true)
          ], 8, _hoisted_41)
        ]))
      : _createCommentVNode("", true)
  ]))
}